import { render, staticRenderFns } from "./Workflow.vue?vue&type=template&id=554595d8&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=js"
export * from "./Workflow.vue?vue&type=script&lang=js"
import style0 from "./Workflow.vue?vue&type=style&index=0&id=554595d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554595d8",
  null
  
)

export default component.exports